import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ProductsDropdown = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hoverIndex, setHoverIndex] = useState(null);

  const sections = [
    { title: "Quality Intelligence", slug: "quality-intelligence", description: "Reactive to Proactive to Predictive ", bg: "#B0C5F9" },
    { title: "Engineering Acceleration", slug: "engineering-acceleration", description: "Reduce development cycles > 10% ", bg: "#BBDFF0" },
    { title: "Fleet Optimization", slug: "fleet-optimization", description: "Unified operations,  ~15% efficiency gain ", bg: "#F7C5D9" },
    { title: "Data Monetization", slug: "data-monetization", description: "Unlock Multi-billion-dollar opportunity", bg: "#F6B483" },
    { title: "Customer Experience", slug: "customer-experience", description: "Transform journeys", bg: "#B0C5F9" },
    { title: "Compliance & Sustainability", slug: "compliance-and-sustainability", description: "Compliance: A strategic competitive edge", bg: "#9DDCD2" },
  ];

  const defaultBg = "#ECEAEB";
  const currentProductName = decodeURIComponent(location.pathname.replace("/product/", ""));
  const isMobile = window.innerWidth < 1024;

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "1.5rem",
        boxShadow: "0px 4px 4px 0px rgba(249, 245, 245, 0.25)",
        zIndex: "9999",
      }}
    >
      {/* Product Sections */}
      <div style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
        gap: isMobile ? "0" : "1rem",
      }}>
        {sections.map((item, idx) => {
          const isActive = currentProductName === item.slug;
          const isHovered = hoverIndex === idx;
          const bgColor = isHovered ? "#D2D2D2" : isActive ? item.bg : defaultBg;

          return (
            <div
              key={idx}
              style={{
                backgroundColor: isMobile ? "none" : bgColor,
                padding: "16px",
                borderRadius: isMobile ? "0" : "6px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                height: window.innerWidth < 1024 ? "80px" : "105px",
                boxShadow: !isMobile && (isHovered || isActive ? "0 4px 12px rgba(0,0,0,0.12)" : "none"),
                borderBottom: isMobile ? "1px solid #f0f0f0" : "none",
              }}
              onClick={() => navigate(`/product/${item.slug}`)}
              onMouseEnter={() => setHoverIndex(idx)}
              onMouseLeave={() => setHoverIndex(null)}
            >
              <div
                style={{
                  fontWeight: 600,
                  fontSize: isMobile ? "34px" : "18px", 
                  marginBottom: !isMobile ? "0.8rem" : 0,
                  color: isMobile && isActive ? "#F00D69" : "#111827", 
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span>{item.title}</span>
                <img
                  src="/assets/fonts/icons/RightIcon.png"
                  alt="arrow"
                  style={{ width: "6px", height: "8px", marginLeft: "10px", fontSize: "18px", }}
                />
              </div>
              {!isMobile && (
                <div style={{ fontSize: "16px", color: "#374151", lineHeight: 1.4 }}>
                  {item.description}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductsDropdown;




